import React, { useEffect, useState } from "react";
import "./home.css";
import Login from "../../Auth/login";
import { Link } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const Home = () => {
  const { isAuthenticated, getUserName, isLoading: authLoading } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [, forceUpdate] = useState();

  useEffect(() => {
    setIsLoading(true);
    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, []);

  // Forzar re-render cuando isAuthenticated cambia
  useEffect(() => {
    forceUpdate({});
  }, [isAuthenticated, authLoading]);

  const Message = () => {
    if (isAuthenticated) {
      const userName = getUserName();
      return (
        <>
          <div className="welcome">
            <p>
              <span>¡Hola {userName}!</span>
              Sigamos jugando, ya falta menos para completar tu álbum.
            </p>
            <p style={{margin: '40px 0'}}>
              <Link className="button button-primary" to="/trivia">
                ¡Ir a las trivias!
              </Link>
            </p>
            <p>
              <Link to="/proyecto" className="button button-secondary">
                Sobre el proyecto
              </Link>
            </p>
          </div>
        </>
      );
    } else {
      return (
        <div>
          <h2>Iniciar sesión</h2>
          <Login />
        </div>
      );
    }
  };

  const LinkAlbum = () => {
    if (isAuthenticated) {
      return (
        <Link to="/album">
          <img
            className="tapa-album"
            src="../../images/tapa-album.jpg"
            alt="album"
            width="500"
          />
        </Link>
      );
    } else {
      return (
        <Link to="/login">
          <img
            className="tapa-album"
            src="../../images/tapa-album.jpg"
            alt="album"
            width="500"
          />
        </Link>
      );
    }
  };

  return (
    <>
      {isLoading && (
        <div className="overlay">
          <div className="loadership loader-front">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      {!isLoading && (
        <div className="main home">
          <div className="col">
            <LinkAlbum />
          </div>
          <div className="col">
            <div className="form-container">
              <Message />
            </div>
            <div className="button-container"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
